export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';
